export enum ScenarioModifyErrorSummaryIds {
  NO_INPUTS = 'no-inputs',
  EMPTY_INPUT = 'empty-input',
  NEGATIVE_INPUT = 'negative-input',
  IS_NAN = 'is-Nan',
  EXCEEDS_PROJECT_LIFETIME = 'exceeds-project-lifetime',
  SMALL_LOAN_DURATION = 'small-loan-duration',
  INVALID_INPUTS = 'invalid-inputs'
}
